// Blueprint: forge/blueprint/frontend/architecture/001-shell-composition.md
import { createRoot } from 'react-dom/client';

import { App } from './app';
import { initFullStory, installFullStorySessionHeader } from './modules/common/analytics/fullstory';
import { installUnauthorizedInterceptor } from './modules/common/api/unauthorized-interceptor';

/*
 * Standalone only: initialize FullStory session capture at bootstrap, before render, so it covers the whole
 * session. Records in deployed environments and is a no-op in local dev (devMode). The embedded MFE
 * deliberately skips this — its host owns FullStory. (User identity is attached later in AuthStore once
 * `/api/me` resolves.)
 */
initFullStory();

/*
 * Standalone only: send the FullStory session id on every API request so the backend can correlate its
 * logs/traces with the session replay. Installed after init so the interceptor reads a live session.
 */
installFullStorySessionHeader();

/*
 * Standalone only: watch every response for a 401 and return the user to the login screen
 * when the BFF session expires. Installed before render so it covers the very first request.
 */
installUnauthorizedInterceptor();

const appContainer = document.createElement('div');
document.body.appendChild(appContainer);

const root = createRoot(appContainer);
root.render(<App />);
